package com.patronat.top.features.auth.di

import com.patronat.top.features.auth.data.network.AuthRemoteDataSource
import com.patronat.top.features.auth.data.repository.AuthRepositoryImpl
import com.patronat.top.features.auth.domain.repository.AuthRepository
import com.patronat.top.features.auth.domain.usecase.*
import com.patronat.top.features.auth.presentation.AuthViewModel
import org.koin.dsl.module

val authFeatureModule = module {

    single{
        AuthRemoteDataSource(httpClient = get())
    }
    single<AuthRepository> {
        AuthRepositoryImpl(
            remoteDataSource = get(),
            tokenStorage = get()
        )
    }

    factory { StartLoginUseCase(repository = get(), dispatcherProvider = get()) }
    factory { StartRegistrationUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ClientConfirmPhoneUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ClientConfirmEmailUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ResendPhoneCodeUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ResendEmailCodeUseCase(repository = get(), dispatcherProvider = get()) }

    factory<AuthViewModel> {
        AuthViewModel(
            alertController = get(),
            startLoginUseCase = get(),
            startRegistrationUseCase = get(),
            confirmPhoneUseCase = get(),
            confirmEmailUseCase = get(),
            resendPhoneCodeUseCase = get(),
            resendEmailCodeUseCase = get()
        )
    }
}